import { Box, Button, Typography } from "@mui/material";
import SearchOffIcon from "@mui/icons-material/SearchOff";
import { Link, Navigate, useLocation } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

// Legacy subscription-era paths (old trial emails, bookmarks): /subscribe,
// /subscription/callback, ... — the routes were removed by CC-PB-2, so they
// fall through to the router's not-found handling; send them to Billing.
const LEGACY_SUBSCRIPTION_PATH = /^\/subscri(be|ption)(\/|$)/;

export function NotFoundPage() {
  const { t } = useTranslation("common");
  const pathname = useLocation({ select: (location) => location.pathname });

  if (LEGACY_SUBSCRIPTION_PATH.test(pathname)) {
    return <Navigate to="/billing" replace />;
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        minHeight: "60vh",
        px: 3,
      }}
    >
      <Box
        sx={{
          color: "text.disabled",
          mb: 2,
          display: "flex",
          "& .MuiSvgIcon-root": { fontSize: 64 },
        }}
      >
        <SearchOffIcon />
      </Box>
      <Typography variant="h5" sx={{ mb: 1, color: "text.primary" }}>
        {t("notFound.title")}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        {t("notFound.description")}
      </Typography>
      <Button component={Link} to="/projects" variant="contained">
        {t("notFound.cta")}
      </Button>
    </Box>
  );
}
